import { useMutation } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { batchSaveDepreciationCorrections } from '../service/depreciationService'
import { DepreciationCorrectionPayload } from '../types'

export const useBatchSaveDepreciationCorrections = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationKey: ['budget', 'investmentDepreciation', 'batchSave'],
    mutationFn: ({
      investmentId,
      corrections
    }: {
      investmentId: number
      corrections: DepreciationCorrectionPayload[]
    }) => batchSaveDepreciationCorrections(companyId, investmentId, corrections, budgetingScenario?.id ?? undefined)
  })
}
